var _circle, _path, _path2, _path3, _line, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTshirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 18L10 26L12.5 38L22.5 36V65.5H57.5V36L67.5 38L70 26L50 18M30 18C33 30.5 47 30.5 50 18M30 18C35 23 45 23 50 18",
    stroke: "#103B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25L15.5 37",
    stroke: "#103B5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 37L67 25",
    stroke: "#103B5D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 62.5,
    x2: 57,
    y2: 62.5,
    stroke: "#103B5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25L30 18C33 30.5 47 30.5 50 18L67 25L64.5 37.5L57.5 36V62.5H22.5V36L15.5 37.5L13 25Z",
    fill: "#103B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshirt);
export default __webpack_public_path__ + "static/media/Tshirt.29c2dfb2fc440f461c8216577d913e0d.svg";
export { ForwardRef as ReactComponent };